import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  form: {
    name: "",
    businessSector: "",
    companySize: "",
    inputs: [],
    isCare: false,
    modules: {},
  },
  activeStep: "addEntity",
};

export const setupSlice = createSlice({
  name: "setup",
  initialState,
  reducers: {
    refreshActiveStep: (state) => {
      state.activeStep = "addEntity";
      return state;
    },
    updateForm: (state, { payload }) => {
      state.form = { ...state.form, ...payload };
    },
    updateActiveStep: (state, { payload }) => {
      state.activeStep = payload;
    },
    resetSetupState: () => initialState,
  },
});

export const {
  updateForm,
  updateActiveStep,
  refreshActiveStep,
  resetSetupState,
} = setupSlice.actions;

export default setupSlice.reducer;
